module.exports = __webpack_public_path__ + "static/media/WorkExperiencePreparationKnowingYourCareer.e0fa68f3.pdf";